module.exports = __webpack_public_path__ + "img/title.c8656cc1.svg";